import {createStore} from 'vuex';
import ProjectsModule from './modules/projects';
import SkillsModule from "./modules/skills";
import ServicesModule from "./modules/services";
import AboutModule from "./modules/about";
import ContactModule from "./modules/contact";

const store = createStore({
    modules: {
        projects: ProjectsModule,
        skills: SkillsModule,
        services: ServicesModule,
        about: AboutModule,
        contact: ContactModule,
    }
})

export default store;